import { render, staticRenderFns } from "./allot.vue?vue&type=template&id=2a161758&scoped=true"
import script from "./allot.vue?vue&type=script&lang=js"
export * from "./allot.vue?vue&type=script&lang=js"
import style0 from "./allot.vue?vue&type=style&index=0&id=2a161758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a161758",
  null
  
)

export default component.exports